// @flow
import React from 'react';
import { MdCheck } from 'react-icons/lib/md';

import styles from './daySelector.css';


type DaySelectorPropTypes = {
  value?: boolean,
  onChange?: Function,
  disabled?: boolean,
  isConflicted?: boolean,
};

const DaySelector = ({
  disabled = false,
  value = false,
  onChange,
  isConflicted = false,
}: DaySelectorPropTypes) => (
  <td
    role="presentation"
    onClick={() => {
      if (!disabled && onChange) {
        onChange(!value);
      }
    }}
    className={
      `
        ${styles.daySelector}
        ${disabled ? styles.disabled : ''}
        ${value ? styles.selected : ''}
        ${isConflicted && value && !disabled ? styles.conflicted : ''}
      `
    }
  >
    {!value && !disabled && <MdCheck className={styles.check} />}
    { value && <MdCheck className={styles.check} /> }
  </td>
);


export default DaySelector;



// WEBPACK FOOTER //
// ./src/scripts/components/WeekSchedule/DaySelector/index.jsx